import PropTypes from 'prop-types';
import React from 'react';

const PdfAttachment = ({ url }) => (
  <div className="attachment attachment--image">
    <a href={url} target="_blank">
      <img src="//s3.amazonaws.com/icmib-error/pdf.png" />
    </a>
  </div>
);

PdfAttachment.propTypes = {
  url: PropTypes.string.isRequired,
};

export default PdfAttachment;
